var map = {
	"app/contact/contact.module": [
		"./src/app/contact/contact.module.ts",
		"contact.module"
	],
	"app/editor/editor.module": [
		"./src/app/editor/editor.module.ts",
		"editor.module"
	],
	"app/overview/overview.module": [
		"./src/app/overview/overview.module.ts",
		"overview.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main